import Axios from "axios";
import {
    SET_HRM_BLOOD_GROUP_TYPE_LIST,
    UNSET_HRM_BLOOD_GROUP_TYPE_LIST,
  } from "@/store/mutation-types";
import {getHrmBloodGroupList} from "@/store/api";
// initial state
const state = {
  getHrmBloodGroupList: [],
};

const getters = {
  getHrmBloodGroupList(state) {
    return state.getHrmBloodGroupList;
  },
};

const mutations = {
  [SET_HRM_BLOOD_GROUP_TYPE_LIST](state, data) {
    state.getHrmBloodGroupList = data;
  },
  [UNSET_HRM_BLOOD_GROUP_TYPE_LIST](state) {
    state.getHrmBloodGroupList = [];
  },

};

const actions = {

  getHrmBloodGroupList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmBloodGroupList, data)
        .then(function (response) {
          commit('SET_HRM_BLOOD_GROUP_TYPE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_BLOOD_GROUP_TYPE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
